import Page from '../page';
import AsyncListManager from "../../helpers/async-list-manager.js";
import {AsyncListManagerEvent} from "../../helpers/async-list-manager.js";

export default class NewsroomIndex extends Page {
    constructor(...args) {
        super(...args);

        this._action = 'pathe_blog_posts_ajax';

        this._retrieveDOM();
    }

    _retrieveDOM() {
        super._retrieveDOM();

        this._filters = { categories: [], countries: [], excludes: null };
        this.dom.load_more = this.dom.page.querySelector('.js-load-more');
        this.dom.container = this.dom.page.querySelector('.news-posts-container');
        this.dom.results = this.dom.container.querySelector('.news-results');
        this.dom.filter_country = this.dom.page.querySelector('.js-filter-country select');
        this.dom.filter_categories_reset = this.dom.page.querySelector('.js-filter-categories-reset');
        this.dom.filter_categories = this.dom.page.querySelectorAll('.js-filter-category');
        this._filters['excludes'] = [];

        this._ALM = new AsyncListManager(this._action, this.dom.load_more);
        this._locked = false;
    }


    bind() {
        super.bind();

        // Load More
        if(this.dom.load_more) {
            this.dom.load_more.addEventListener('click', (e) => {
                if( this._locked == false ) {
                    document.body.classList.add('loading');
                    this.dom.load_more.classList.add('loading');
                    this._locked = true;
                    this._ALM.loadMore(e);
                }
            });
        }

        // Data receive after AJAX call
        this._ALM.on(AsyncListManagerEvent.UPDATED, (xhr) => {
            this._injectData(xhr);
        });

        // Filter categories
        if( this.dom.filter_categories.length && this.dom.filter_categories.length > 0 )
        {
            for( let i = 0, j = this.dom.filter_categories.length; i < j; i++ )
            {
                this.dom.filter_categories[i].addEventListener( 'click', (e) => {
                    this._processCategories(e.currentTarget);
                } )
            }
        }

        // Reset Category click
        if( this.dom.filter_categories_reset )
        {
            this.dom.filter_categories_reset.addEventListener('click', () => {
                if(this.dom.filter_categories_reset.classList.contains('active'))
                    return;
                this.dom.filter_categories_reset.classList.add('active');
                this._resetCategories();

                // this._ALM.load(this._filters);
            });
        }

        // Filter country
        if( this.dom.filter_country )
        {
            this.dom.filter_country.addEventListener('change', (e) => {
                if( this.dom.filter_country.value )
                    this._filters['countries'] = [this.dom.filter_country.value];
                else
                    this._filters['countries'] = [];

                this._ALM.load(this._filters);
            });
        }
    }

    _processCategories( filter ) {

        if( this._locked == false )
        {
            // Clean old value
            for(var i = 0, j = this.dom.filter_categories.length; i < j; i++) {
                this.dom.filter_categories[i].classList.remove('active');
            }

            this._locked = true;
            var id = filter.getAttribute('data-category');

            if( filter.classList.contains( 'active' ) ) {
                this._filters['categories'] = [];
                filter.classList.remove( 'active' );
                this.dom.filter_categories_reset.classList.add('active');
            } else {
                this._filters['categories'] = [ id ];
                filter.classList.add( 'active' );
                this.dom.filter_categories_reset.classList.remove('active');
            }

            // Retrieve
            this._ALM.load(this._filters);
        }

    }

    _resetCategories() {

        for(var i = 0, j = this.dom.filter_categories.length; i < j; i++) {
            this.dom.filter_categories[i].classList.remove('active');
        }
        this._filters['categories'] = [];

        // Retrieve
        this._ALM.load(this._filters);
    }

    _injectData(xhr) {
        this._locked = false;

        // Check if there is result
        if(xhr.data.has_results == false) {
            this._toggleNoResult();
            this.hideLoadMore();
        } else {
            this.dom.container.classList.remove('no-results');
            // Check if there is other data to load
            if(xhr.data.load_more == true)
                this.showLoadMore();
            else
                this.hideLoadMore();

            if(xhr.data.page == 1) {
                this.dom.results.innerHTML = xhr.data.posts_html;
            } else {
                this.dom.results.insertAdjacentHTML('beforeend', xhr.data.posts_html);
            }

            this.newItems = document.querySelectorAll('.to-animate');
            for(var i = 0, j = this.newItems.length; i < j; i++)
            {
                var delay = (i + 1) * 110;
                this._animateResult(i, delay);
            }
        }

        document.body.classList.remove('loading');
        this.dom.load_more.classList.remove('loading');
    }

    hideLoadMore() {
        if( this.dom.load_more )
            this.dom.load_more.classList.add('hidden');
    }

    showLoadMore() {
        if( this.dom.load_more )
            this.dom.load_more.classList.remove('hidden');
    }

    _animateResult(index, delay) {
        setTimeout(() => {
            this.newItems[index].classList.remove('to-animate');
        }, delay);
    }

    _toggleNoResult() {
        this.dom.container.classList.add('no-results');
        this.dom.results.innerHTML = '';
    }

    _resetFilters() {

        for(var i = 0, j = this.dom.filters.length; i < j; i++) {
            this.dom.filters[i].classList.remove('active');
        }

        this._filters['categories'] = [];
        this._filters['countries'] = [];

        // Retrieve
        this._ALM.load(this._filters);

    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}


// WEBPACK FOOTER //
// src/js/pages/newsroom/newsroom.js